import { HTMLAttributes } from 'react';
import cx from 'classnames';

export type CardVariant = 'outline' | 'raised';
export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** `raised` adds the shadow — for a card that sits on the grey page background. */
  variant?: CardVariant;
  padding?: CardPadding;
  /** `control` (10px) for a block inside a panel — the journal's report sections; `card` (20px) on the page. */
  radius?: 'card' | 'control';
}

const variantClasses: Record<CardVariant, string> = {
  outline: '',
  raised: 'shadow-raised',
};

const paddingClasses: Record<CardPadding, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6 md:p-8',
};

/** The one white surface of the app. Layout of what is inside belongs to the caller's `className`. */
export const Card = ({ variant = 'outline', padding = 'md', radius = 'card', className, ...rest }: CardProps) => (
  <div
    className={cx(
      'border border-line bg-surface',
      radius === 'card' ? 'rounded-card' : 'rounded-control',
      variantClasses[variant],
      paddingClasses[padding],
      className,
    )}
    {...rest}
  />
);
